<div class="section">
    <div class="header">
        <div><mat-icon>keyboard_double_arrow_down</mat-icon><span>Report Type</span></div>
        <div *ngFor="let desc of alertDescriptions"><span>{{desc}}</span></div>
        <div><span>Closed</span></div>
        <div><span>Deferred</span></div>
        <div><span>Total</span></div>
    </div>


    <div *ngFor="let r of summaryResponse; last as last" [ngClass]="{'border-b': !last}" (click)="r.expand = !r.expand">
        <!-- <div class="flex-row-container p-tb-5 hover-effect pointer"  > -->

        <div class="division-accordion">
            <div class="data-row">
                <div><span class="icon-align-centre"> <mat-icon [class.expand-arrow]="true" [class.expanded]="r.expand">
                            {{ r.expand ? 'expand_less' : 'expand_more' }}
                        </mat-icon></span><span class="stat-value">
                        <div class="report-name">{{r.smryItems[0]?.rptDesc}}</div>
                        <div class="report-count"> {{r.smryItems.length}} reports</div>
                    </span></div>
                <div *ngFor="let desc of alertDescriptions"><span [style.color]="getAlertColor(r.rptType, desc, getTypeOpenCount(r, desc))">{{getTypeOpenCount(r, desc)}}</span></div>
                <div><span>{{zeroAsDash(r.closedCt)}}</span></div>
                <div><span>{{zeroAsDash(r.deferredCt)}}</span></div>
                <div><span>{{zeroAsDash(r.totalCt)}}</span></div>

            </div>
            <!-- </div> -->
            <div *ngIf="r.expand && r.smryItems && r.smryItems.length" class="w3-animate-opacity ">
                <a class="accordian-row" *ngFor="let i of r.smryItems" target="frmodashboard" (click)="goToSupervisionReport(i.rptType, i.year, i.month, $event)">
                    <div  title="{{i.rptDesc}}"><span class="m-l-10">{{i.monthName}}-{{i.year}}</span></div>
                    <div *ngFor="let desc of alertDescriptions"><a (click)="getOpenCount(i, desc) !== '--' ? goToSupervisionReport(i.rptType, i.year, i.month, $event, desc) : $event.stopPropagation()" [style.cursor]="getOpenCount(i, desc) !== '--' ? 'pointer' : 'default'" style="text-decoration:none"><span [style.color]="getAlertColor(i.rptType, desc, getOpenCount(i, desc))">{{getOpenCount(i, desc)}}</span></a></div>
                    <div (click)="zeroAsDash(i.closedCt) !== '--' ? goToSupervisionReport(i.rptType, i.year, i.month, $event, 'Closed') : $event.stopPropagation()" [style.cursor]="zeroAsDash(i.closedCt) === '--' ? 'default' : 'pointer'"><span>{{zeroAsDash(i.closedCt)}}</span></div>
                    <div (click)="zeroAsDash(i.deferredCt) !== '--' ? goToSupervisionReport(i.rptType, i.year, i.month, $event, 'Deferred') : $event.stopPropagation()" [style.cursor]="zeroAsDash(i.deferredCt) === '--' ? 'default' : 'pointer'"><span>{{zeroAsDash(i.deferredCt)}}</span></div>
                    <div (click)="zeroAsDash(i.totalCt) === '--' && $event.stopPropagation()" [style.cursor]="zeroAsDash(i.totalCt) === '--' ? 'default' : 'pointer'"><span>{{zeroAsDash(i.totalCt)}}</span></div>
                </a>
            </div>
        </div>
    </div>

</div>